export default function GoogleNavigateItem({url, isSmall, onClick}) {
    
    const handleClick = (e) => {
        onClick();
        e.stopPropagation(); // Prevent the click from bubbling to parent
    };

    return <a 
    href={url} 
    target="_blank" 
    rel="noopener noreferrer"
    onClick={handleClick}
    >
        <button className={`btn ${isSmall ? "text-sm btn-sm": "text-base"} btn-primary normal-case rounded-full`}>
            <span className={`${isSmall ? "text-xs": "text-base"} `}>Navigate</span>
            <svg className={`${isSmall ? "w-3 h-3" : "w-4 h-4"}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path className="fill-primary-content" d="M9 10a1 1 0 0 0-1 1v4h2v-3h3v2.5l3.5-3.5L13 7.5V10H9zm3.707-8.607l9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0z"/>
                </g>
            </svg>
    </button>
    </a>
}